/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getAzureService } from 'src/core/services/azure/azureService';
import { getAzureOpenAiService } from 'src/core/services/azureOpenAiService';
import { AzureCsAccountStore } from 'src/core/stores/AzureCsAccountStore';
import { HandlerGroupFactoryDeps, HandlerParams } from 'src/core/types/handler';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';

export type AzureOpenAiHandlerGroup = ReturnType<typeof createAzureOpenAiHandlerGroup>;

export const createAzureOpenAiHandlerGroup = (dependencies: HandlerGroupFactoryDeps) => {
    const { rootStore } = dependencies;

    const getAzureOpenAiDeployments = async ({
        resource,
        deploymentsStoreHouse
    }: HandlerParams<{
        resource: AzureCsAccountStore;
        deploymentsStoreHouse: ResourceStoreHouse<{ id: string; deploymentName: string }>;
    }>) => {
        deploymentsStoreHouse.tracker.setState('running');

        try {
            // fetch resource keys
            const tenantToken = rootStore.azureStore.session.userTokens.armToken;
            const keys = await getAzureService().getAzureCsAccountKeyStringsByPath({ tenantToken, path: resource.path });

            const deploymentsSwaggers = await getAzureOpenAiService().getAzureOpenAiDeployments({
                serviceKey: keys.key1,
                endpoint: resource.endpoint
            });

            deploymentsStoreHouse.setItems(deploymentsSwaggers.map(d => ({ deploymentName: d.id, id: d.id })));
            deploymentsStoreHouse.tracker.setState('completed');
        } catch (e) {
            deploymentsStoreHouse.tracker.setState('failed', e);
        }
    };

    return { getAzureOpenAiDeployments };
};
